export default __webpack_public_path__ + "static/Map_BG_Image-1febce2237ccfa543c7458cc44f70f13.jpg";